import get from 'lodash/get';
import { PROFILE_FIELDS } from '../../../constants/strings';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

const { EMAIL, PHONE_NUMBER, ADDRESS_1, CITY, STATE } = PROFILE_FIELDS_TYPES;

export function convertList(formatMessage, user) {
  const getFieldParam = field => get(user, field) || '-';

  return [
    [
      {
        title: formatMessage(PROFILE_FIELDS.fieldNames.email),
        subtitle: getFieldParam(EMAIL),
      },
      {
        title: formatMessage(PROFILE_FIELDS.fieldNames.phones),
        subtitle: getFieldParam(PHONE_NUMBER),
      },
    ],
    [
      {
        title: formatMessage(PROFILE_FIELDS.fieldNames.address1),
        subtitle: getFieldParam(ADDRESS_1),
      },
      {
        title: formatMessage(PROFILE_FIELDS.fieldNames.city),
        subtitle: getFieldParam(CITY),
      },
    ],
    [
      {
        title: formatMessage(PROFILE_FIELDS.fieldNames.state),
        subtitle: getFieldParam(STATE),
      },
    ],
  ];
}



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/utils/convertExistingUsersList.js